/**
 * Format a UTC date string for display.
 * Used by the table's "Last Modified" and "Created by" date cells.
 */
export const formatDate = (dateString: string): string => {
  const date = new Date(dateString);
  return date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });
};
